//App - start
export const COLLAPSE_MENU = "COLLAPSE_MENU";
export const COLLAPSE_TOGGLE = "COLLAPSE_TOGGLE";
export const FULL_SCREEN = "FULL_SCREEN";
export const FULL_SCREEN_EXIT = "FULL_SCREEN_EXIT";
export const CHANGE_LAYOUT = "CHANGE_LAYOUT";
export const NAV_CONTENT_LEAVE = "NAV_CONTENT_LEAVE";
export const NAV_COLLAPSE_LEAVE = "NAV_COLLAPSE_LEAVE";

export const SET_LOADER = "SET_LOADER";
export const GLOBAL_SHOW_PROFILE = "GLOBAL_SHOW_PROFILE";
export const GLOBAL_HIDE_PROFILE = "GLOBAL_HIDE_PROFILE";
//App - end

// GLOBAL
export const GLOBAL_GET_MASTER_DATA = "GLOBAL_GET_MASTER_DATA";
export const GLOBAL_GET_MASTER_DATA_SUCCESS = "GLOBAL_GET_MASTER_DATA_SUCCESS";

//DASHBOARD
export const DASHBOARD_SET_LOADER = "DASHBOARD_SET_LOADER";
export const DASHBOARD_DOKTER_SET_LOADER = "DASHBOARD_DOKTER_SET_LOADER";
export const GET_LIST_RESERVASI = "GET_LIST_RESERVASI";
export const GET_LIST_RESERVASI_SUCCESS = "GET_LIST_RESERVASI_SUCCESS";
export const HANDLE_STATE_OUTER = "HANDLE_STATE_OUTER";
export const GET_LIST_KONSULTASI = "GET_LIST_KONSULTASI";
export const GET_LIST_KONSULTASI_SUCCESS = "GET_LIST_KONSULTASI_SUCCESS";
export const DASHBOARD_ADMISI_ACCEPT_RESERVASI = "DASHBOARD_ADMISI_ACCEPT_RESERVASI";
export const DASHBOARD_ADMISI_DECLINE_RESERVASI = "DASHBOARD_ADMISI_DECLINE_RESERVASI";
export const DASHBOARD_ADMISI_LISTDATA_KUNJUNGAN_PASIEN = "DASHBOARD_ADMISI_LISTDATA_KUNJUNGAN_PASIEN";
export const DASHBOARD_ADMISI_LISTDATA_KUNJUNGAN_PASIEN_SUCCESS = "DASHBOARD_ADMISI_LISTDATA_KUNJUNGAN_PASIEN_SUCCESS";
export const DASHBOARD_ADMISI_PEMASUKAN_HARIAN = "DASHBOARD_ADMISI_PEMASUKAN_HARIAN";
export const DASHBOARD_ADMISI_PEMASUKAN_HARIAN_SUCCESS = "DASHBOARD_ADMISI_PEMASUKAN_HARIAN_SUCCESS";

export const DASHBOARD_APOTEK_SET_LOADER = "DASHBOARD_APOTEK_SET_LOADER";
export const DASHBOARD_APOTEK_RESERVASI_RESEP_OBAT = "DASHBOARD_APOTEK_RESERVASI_RESEP_OBAT";
export const DASHBOARD_APOTEK_RESERVASI_RESEP_OBAT_BY_ID = "DASHBOARD_APOTEK_RESERVASI_RESEP_OBAT_BY_ID";
export const DASHBOARD_APOTEK_RESERVASI_RESEP_OBAT_ALL_SUCCESS = "DASHBOARD_APOTEK_RESERVASI_RESEP_OBAT_ALL_SUCCESS";
export const DASHBOARD_APOTEK_RESERVASI_RESEP_OBAT_DETAIL_SUCCESS = "DASHBOARD_APOTEK_RESERVASI_RESEP_OBAT_DETAIL_SUCCESS";
export const DASHBOARD_APOTEK_RESERVASI_RESEP_OBAT_FINISH = "DASHBOARD_APOTEK_RESERVASI_RESEP_OBAT_FINISH";

// MODULE PASIEN
export const MODULE_PASIEN_SET_LOADER = "MODULE_PASIEN_SET_LOADER";
export const INIT_FORM_TAMBAH_PASIEN = "INIT_FORM_TAMBAH_PASIEN";
export const MODULE_PASIEN_MASTER_DATA = "MODULE_PASIEN_MASTER_DATA";
export const MODULE_PASIEN_MASTER_DATA_SUCCESS = "MODULE_PASIEN_MASTER_DATA_SUCCESS";
export const HANDLE_STATE_FORM_TAMBAH_PASIEN = "HANDLE_STATE_FORM_TAMBAH_PASIEN";
export const MODULE_PASIEN_SUBMIT_FORM = "MODULE_PASIEN_SUBMIT_FORM";
export const MODULE_PASIEN_DATA_GET = "MODULE_PASIEN_DATA_GET";
export const MODULE_PASIEN_DATA_GET_ALL_SUCCESS = "MODULE_PASIEN_DATA_GET_ALL_SUCCESS";
export const MODULE_PASIEN_DATA_GET_DETAIL_SUCCESS = "MODULE_PASIEN_DATA_GET_DETAIL_SUCCESS";

// MODULE LAYANAN
export const MODULE_LAYANAN_MASTER_DATA = "MODULE_LAYANAN_MASTER_DATA";
export const MODULE_LAYANAN_MASTER_DATA_SUCCESS = "MODULE_LAYANAN_MASTER_DATA_SUCCESS";
export const MODULE_LAYANAN_SET_LOADER = "MODULE_LAYANAN_SET_LOADER";
export const MODULE_LAYANAN_DATA_GET = "MODULE_LAYANAN_DATA_GET";
export const MODULE_LAYANAN_DATA_GET_ALL_SUCCESS = "MODULE_LAYANAN_DATA_GET_ALL_SUCCESS";
export const MODULE_LAYANAN_DATA_GET_DETAIL_SUCCESS = "MODULE_LAYANAN_DATA_GET_DETAIL_SUCCESS";
export const MODULE_LAYANAN_INIT_FORM_LAYANAN = "MODULE_LAYANAN_INIT_FORM_LAYANAN";
export const MODULE_LAYANAN_HANDLE_STATE_FORM = "MODULE_LAYANAN_HANDLE_STATE_FORM";
export const MODULE_LAYANAN_SUBMIT_FORM = "MODULE_LAYANAN_SUBMIT_FORM";

// MODULE POLI
export const MODULE_POLI_SET_LOADER = "MODULE_POLI_SET_LOADER";
export const MODULE_POLI_MASTER_DATA = "MODULE_POLI_MASTER_DATA";
export const MODULE_POLI_MASTER_DATA_SUCCESS = "MODULE_POLI_MASTER_DATA_SUCCESS";
export const MODULE_POLI_DATA_GET = "MODULE_POLI_DATA_GET";
export const MODULE_POLI_DATA_GET_ALL_SUCCESS = "MODULE_POLI_DATA_GET_ALL_SUCCESS";
export const MODULE_POLI_DATA_GET_DETAIL_SUCCESS = "MODULE_POLI_DATA_GET_DETAIL_SUCCESS";
export const MODULE_POLI_INIT_FORM_POLI = "MODULE_POLI_INIT_FORM_POLI";
export const MODULE_POLI_HANDLE_STATE_FORM = "MODULE_POLI_HANDLE_STATE_FORM";
export const MODULE_POLI_SUBMIT_FORM = "MODULE_POLI_SUBMIT_FORM";

// MODULE OBAT
export const MODULE_OBAT_SET_LOADER = "MODULE_OBAT_SET_LOADER";
export const MODULE_OBAT_MASTER_DATA = "MODULE_OBAT_MASTER_DATA";
export const MODULE_OBAT_MASTER_DATA_SUCCESS = "MODULE_OBAT_MASTER_DATA_SUCCESS";
export const MODULE_OBAT_DATA_GET = "MODULE_OBAT_DATA_GET";
export const MODULE_OBAT_DATA_GET_ALL_SUCCESS = "MODULE_OBAT_DATA_GET_ALL_SUCCESS";
export const MODULE_OBAT_DATA_GET_DETAIL_SUCCESS = "MODULE_OBAT_DATA_GET_DETAIL_SUCCESS";
export const MODULE_OBAT_MASUK_DATA_GET = "MODULE_OBAT_MASUK_DATA_GET";
export const MODULE_OBAT_MASUK_DATA_GET_ALL_SUCCESS = "MODULE_OBAT_MASUK_DATA_GET_ALL_SUCCESS";
export const MODULE_OBAT_MASUK_DATA_GET_DETAIL_SUCCESS = "MODULE_OBAT_MASUK_DATA_GET_DETAIL_SUCCESS";
export const MODULE_OBAT_KELUAR_DATA_GET = "MODULE_OBAT_KELUAR_DATA_GET";
export const MODULE_OBAT_KELUAR_DATA_GET_ALL_SUCCESS = "MODULE_OBAT_KELUAR_DATA_GET_ALL_SUCCESS";
export const MODULE_OBAT_KELUAR_DATA_GET_DETAIL_SUCCESS = "MODULE_OBAT_KELUAR_DATA_GET_DETAIL_SUCCESS";

export const MODULE_OBAT_INIT_FORM_OBAT = "MODULE_OBAT_INIT_FORM_OBAT";
export const MODULE_OBAT_HANDLE_STATE_FORM = "MODULE_OBAT_HANDLE_STATE_FORM";
export const MODULE_OBAT_SUBMIT_FORM = "MODULE_OBAT_SUBMIT_FORM";
export const MODULE_OBAT_MASUK_INIT_FORM_OBAT = "MODULE_OBAT_MASUK_INIT_FORM_OBAT";
export const MODULE_OBAT_MASUK_HANDLE_STATE_FORM = "MODULE_OBAT_MASUK_HANDLE_STATE_FORM";
export const MODULE_OBAT_MASUK_SUBMIT_FORM = "MODULE_OBAT_MASUK_SUBMIT_FORM";

// MODULE DOKTER
export const MODULE_DOKTER_SET_LOADER = "MODULE_DOKTER_SET_LOADER";
export const MODULE_DOKTER_MASTER_DATA = "MODULE_DOKTER_MASTER_DATA";
export const MODULE_DOKTER_MASTER_DATA_SUCCESS = "MODULE_DOKTER_MASTER_DATA_SUCCESS";
export const MODULE_DOKTER_DATA_GET = "MODULE_DOKTER_DATA_GET";
export const MODULE_DOKTER_DATA_GET_ALL_SUCCESS = "MODULE_DOKTER_DATA_GET_ALL_SUCCESS";
export const MODULE_DOKTER_DATA_GET_DETAIL_SUCCESS = "MODULE_DOKTER_DATA_GET_DETAIL_SUCCESS";
export const MODULE_DOKTER_DATA_GET_LIST_DOKTER_PRAKTEK = "MODULE_DOKTER_DATA_GET_LIST_DOKTER_PRAKTEK";
export const MODULE_DOKTER_DATA_GET_LIST_DOKTER_PRAKTEK_SUCCESS = "MODULE_DOKTER_DATA_GET_LIST_DOKTER_PRAKTEK_SUCCESS";
export const MODULE_DOKTER_INIT_FORM_DOKTER = "MODULE_DOKTER_INIT_FORM_DOKTER";
export const MODULE_DOKTER_INIT_FORM_DOKTER_KLINIK = "MODULE_DOKTER_INIT_FORM_DOKTER_KLINIK";
export const MODULE_DOKTER_INIT_FORM_CARI_DOKTER = "MODULE_DOKTER_INIT_FORM_CARI_DOKTER";
export const MODULE_DOKTER_INIT_FORM_JADWAL_PRAKTEK = "MODULE_DOKTER_INIT_FORM_JADWAL_PRAKTEK";
export const MODULE_DOKTER_HANDLE_STATE_FORM = "MODULE_DOKTER_HANDLE_STATE_FORM";
export const MODULE_DOKTER_HANDLE_STATE_CARI_DOKTER = "MODULE_DOKTER_HANDLE_STATE_CARI_DOKTER";
export const MODULE_DOKTER_HANDLE_STATE_DOKTER_PRAKTEK = "MODULE_DOKTER_HANDLE_STATE_DOKTER_PRAKTEK";
export const MODULE_DOKTER_HANDLE_STATE_JADWAL_PRAKTEK = "MODULE_DOKTER_HANDLE_STATE_JADWAL_PRAKTEK";
export const MODULE_DOKTER_HANDLE_STATE_JADWAL_PRAKTEK2 = "MODULE_DOKTER_HANDLE_STATE_JADWAL_PRAKTEK2";
export const MODULE_DOKTER_HANDLE_STATE_OUTER = "MODULE_DOKTER_HANDLE_STATE_OUTER";
export const MODULE_DOKTER_HANDLE_ADD_JADWAL = "MODULE_DOKTER_HANDLE_ADD_JADWAL";
export const MODULE_DOKTER_HANDLE_DEL_JADWAL = "MODULE_DOKTER_HANDLE_DEL_JADWAL";
export const MODULE_DOKTER_SUBMIT_FORM = "MODULE_DOKTER_SUBMIT_FORM";
export const MODULE_DOKTER_SUBMIT_FORM_DOKTER_PRAKTEK = "MODULE_DOKTER_SUBMIT_FORM_DOKTER_PRAKTEK";
export const MODULE_DOKTER_SUBMIT_FORM_JADWAL_PRAKTEK = "MODULE_DOKTER_SUBMIT_FORM_JADWAL_PRAKTEK";
export const MODULE_DOKTER_VALIDATE_CODE = "MODULE_DOKTER_VALIDATE_CODE";
export const MODULE_DOKTER_VALIDATE_CODE_SUCCESS = "MODULE_DOKTER_VALIDATE_CODE_SUCCESS";
export const MODULE_DOKTER_RIWAYAT_PENYAKIT_PASIEN = "MODULE_DOKTER_RIWAYAT_PENYAKIT_PASIEN";
export const MODULE_DOKTER_RIWAYAT_PENYAKIT_PASIEN_SUCCESS = "MODULE_DOKTER_RIWAYAT_PENYAKIT_PASIEN_SUCCESS";

// DIAGNOSA
export const MODULE_DOKTER_CHECK_STATUS_DIAGNOSA = "MODULE_DOKTER_CHECK_STATUS_DIAGNOSA";
export const MODULE_DOKTER_CHECK_STATUS_DIAGNOSA_SUCCESS = "MODULE_DOKTER_CHECK_STATUS_DIAGNOSA_SUCCESS";
export const MODULE_DOKTER_HANDLE_STATE_DIAGNOSA1 = "MODULE_DOKTER_HANDLE_STATE_DIAGNOSA1";
export const MODULE_DOKTER_HANDLE_STATE_DIAGNOSA2 = "MODULE_DOKTER_HANDLE_STATE_DIAGNOSA2";
export const MODULE_DOKTER_HANDLE_STATE_DIAGNOSA3 = "MODULE_DOKTER_HANDLE_STATE_DIAGNOSA3";
export const MODULE_DOKTER_HANDLE_STATE_DIAGNOSA4 = "MODULE_DOKTER_HANDLE_STATE_DIAGNOSA4";
export const MODULE_DOKTER_HANDLE_STATE_DIAGNOSA1_SUCCESS = "MODULE_DOKTER_HANDLE_STATE_DIAGNOSA1_SUCCESS";
export const MODULE_DOKTER_TO_DIAGNOSA2 = "MODULE_DOKTER_TO_DIAGNOSA2";
export const MODULE_DOKTER_TO_DIAGNOSA2_SUCCESS = "MODULE_DOKTER_TO_DIAGNOSA2_SUCCESS";
export const MODULE_DOKTER_TO_DIAGNOSA3 = "MODULE_DOKTER_TO_DIAGNOSA3";
export const MODULE_DOKTER_TO_DIAGNOSA3_SUCCESS = "MODULE_DOKTER_TO_DIAGNOSA3_SUCCESS";
export const MODULE_DOKTER_SUBMIT_FORM_DIAGNOSA1 = "MODULE_DOKTER_SUBMIT_FORM_DIAGNOSA1";
export const MODULE_DOKTER_SUBMIT_FORM_DIAGNOSA2 = "MODULE_DOKTER_SUBMIT_FORM_DIAGNOSA2";
export const MODULE_DOKTER_SUBMIT_FORM_DIAGNOSA3 = "MODULE_DOKTER_SUBMIT_FORM_DIAGNOSA3";
export const MODULE_DOKTER_SUBMIT_FORM_DIAGNOSA4 = "MODULE_DOKTER_SUBMIT_FORM_DIAGNOSA4";
export const MODULE_DOKTER_INIT_FORM_DIAGNOSA1 = "MODULE_DOKTER_INIT_FORM_DIAGNOSA1";
export const MODULE_DOKTER_INIT_FORM_DIAGNOSA2 = "MODULE_DOKTER_INIT_FORM_DIAGNOSA2";
export const MODULE_DOKTER_INIT_FORM_DIAGNOSA3 = "MODULE_DOKTER_INIT_FORM_DIAGNOSA3";
export const MODULE_DOKTER_INIT_FORM_DIAGNOSA4 = "MODULE_DOKTER_INIT_FORM_DIAGNOSA4";

export const MODULE_DOKTER_HANDLE_STATE_FORM_MODAL_LAYANAN = "MODULE_DOKTER_HANDLE_STATE_FORM_MODAL";
export const MODULE_DOKTER_HANDLE_STATE_FORM_MODAL_OBAT = "MODULE_DOKTER_HANDLE_STATE_FORM_MODAL_OBAT";
export const MODULE_DOKTER_HANDLE_ADD_LAYANAN_TO_LIST = "MODULE_DOKTER_HANDLE_ADD_LAYANAN_TO_LIST";
export const MODULE_DOKTER_HANDLE_ADD_LAYANAN_TO_LIST_SUCCESS = "MODULE_DOKTER_HANDLE_ADD_LAYANAN_TO_LIST_SUCCESS";
export const MODULE_DOKTER_HANDLE_ADD_OBAT_TO_LIST = "MODULE_DOKTER_HANDLE_ADD_OBAT_TO_LIST";
export const MODULE_DOKTER_HANDLE_ADD_OBAT_TO_LIST_SUCCESS = "MODULE_DOKTER_HANDLE_ADD_OBAT_TO_LIST_SUCCESS";
export const MODULE_DOKTER_DROPDOWN_LAYANAN_GET = "MODULE_DOKTER_DROPDOWN_LAYANAN_GET";
export const MODULE_DOKTER_DROPDOWN_LAYANAN_GET_SUCCESS = "MODULE_DOKTER_DROPDOWN_LAYANAN_GET_SUCCESS";
export const MODULE_DOKTER_LISTDATA_LAYANAN_GET = "MODULE_DOKTER_LISTDATA_LAYANAN_GET";
export const MODULE_DOKTER_LISTDATA_LAYANAN_GET_SUCCESS = "MODULE_DOKTER_LISTDATA_LAYANAN_GET_SUCCESS";
export const MODULE_DOKTER_DROPDOWN_OBAT_GET = "MODULE_DOKTER_DROPDOWN_OBAT_GET";
export const MODULE_DOKTER_DROPDOWN_OBAT_GET_SUCCESS = "MODULE_DOKTER_DROPDOWN_OBAT_GET_SUCCESS";
export const MODULE_DOKTER_LISTDATA_OBAT_GET = "MODULE_DOKTER_LISTDATA_OBAT_GET";
export const MODULE_DOKTER_LISTDATA_OBAT_GET_SUCCESS = "MODULE_DOKTER_LISTDATA_OBAT_GET_SUCCESS";
export const MODULE_DOKTER_SUBMIT_MODAL_LAYANAN = "MODULE_DOKTER_SUBMIT_MODAL_LAYANAN";
export const MODULE_DOKTER_SUBMIT_MODAL_OBAT = "MODULE_DOKTER_SUBMIT_MODAL_OBAT";
export const MODULE_DOKTER_DROPDOWN_ICD_GET = "MODULE_DOKTER_DROPDOWN_ICD_GET";
export const MODULE_DOKTER_DROPDOWN_ICD_GET_SUCCESS = "MODULE_DOKTER_DROPDOWN_ICD_GET_SUCCESS";

// MODULE RESERVASI
export const MODULE_RESERVASI_SET_LOADER = "MODULE_RESERVASI_SET_LOADER";
export const MODULE_RESERVASI_MASTER_DATA = "MODULE_RESERVASI_MASTER_DATA";
export const MODULE_RESERVASI_MASTER_DATA_SUCCESS = "MODULE_RESERVASI_MASTER_DATA_SUCCESS";
export const MODULE_RESERVASI_INIT_FORM_CARI_PASIEN = "MODULE_RESERVASI_INIT_FORM_CARI_PASIEN";
export const MODULE_RESERVASI_INIT_FORM_RESERVASI = "MODULE_RESERVASI_INIT_FORM_RESERVASI";
export const MODULE_RESERVASI_VALIDATE_CODE = "MODULE_RESERVASI_VALIDATE_CODE";
export const MODULE_RESERVASI_VALIDATE_CODE_SUCCESS = "MODULE_RESERVASI_VALIDATE_CODE_SUCCESS";
export const MODULE_RESERVASI_VALIDATE_DOKTER_DAN_POLI = "MODULE_RESERVASI_VALIDATE_DOKTER_DAN_POLI";
export const MODULE_RESERVASI_VALIDATE_DOKTER_DAN_POLI_SUCCESS = "MODULE_RESERVASI_VALIDATE_DOKTER_DAN_POLI_SUCCESS";
export const MODULE_RESERVASI_VALIDATE_DOKTER_DAN_POLI_RESET = "MODULE_RESERVASI_VALIDATE_DOKTER_DAN_POLI_RESET";
export const MODULE_RESERVASI_HANDLE_STATE_CARI_PASIEN = "MODULE_RESERVASI_HANDLE_STATE_CARI_PASIEN";
export const MODULE_RESERVASI_HANDLE_STATE_RESERVASI = "MODULE_RESERVASI_HANDLE_STATE_RESERVASI";
export const MODULE_RESERVASI_SUBMIT_FORM_RESERVASI = "MODULE_RESERVASI_SUBMIT_FORM_RESERVASI";

// MODULE KASIR
export const MODULE_KASIR_SET_LOADER = "MODULE_KASIR_SET_LOADER";
export const MODULE_KASIR_LISTDATA_RESERVASI_GET = "MODULE_KASIR_LISTDATA_RESERVASI_GET";
export const MODULE_KASIR_LISTDATA_RESERVASI_GET_SUCCESS = "MODULE_KASIR_LISTDATA_RESERVASI_GET_SUCCESS";
export const MODULE_KASIR_DETAIL_RESERVASI_GET = "MODULE_KASIR_DETAIL_RESERVASI_GET";
export const MODULE_KASIR_DETAIL_RESERVASI_GET_SUCCESS = "MODULE_KASIR_DETAIL_RESERVASI_GET_SUCCESS";
export const MODULE_KASIR_HANDLE_STATE_FORM_PEMBAYARAN = "MODULE_KASIR_HANDLE_STATE_FORM_PEMBAYARAN";
export const MODULE_KASIR_SUBMIT_FORM_INVOICE_RESERVASI = "MODULE_KASIR_SUBMIT_FORM_INVOICE_RESERVASI";

// MODULE USER MEDIS
export const MODULE_USERMEDIS_SET_LOADER = "MODULE_USERMEDIS_SET_LOADER";
export const MODULE_USERMEDIS_MASTER_DATA = "MODULE_USERMEDIS_MASTER_DATA";
export const MODULE_USERMEDIS_MASTER_DATA_SUCCESS = "MODULE_USERMEDIS_MASTER_DATA_SUCCESS";
export const MODULE_USERMEDIS_LISTDATA_USERMEDIS = "MODULE_USERMEDIS_LISTDATA_USERMEDIS";
export const MODULE_USERMEDIS_LISTDATA_USERMEDIS_SUCCESS = "MODULE_USERMEDIS_LISTDATA_USERMEDIS_SUCCESS";
export const MODULE_USERMEDIS_DETAIL_USERMEDIS_GET = "MODULE_USERMEDIS_DETAIL_USERMEDIS_GET";
export const MODULE_USERMEDIS_DETAIL_USERMEDIS_GET_SUCCESS = "MODULE_USERMEDIS_DETAIL_USERMEDIS_GET_SUCCESS";
export const MODULE_USERMEDIS_HANDLE_STATE_FORM = "MODULE_USERMEDIS_HANDLE_STATE_FORM";
export const MODULE_USERMEDIS_SUBMIT_FORM_USERMEDIS = "MODULE_USERMEDIS_SUBMIT_FORM_USERMEDIS";

// AUTH LOGIN
export const MODULE_AUTH_SET_LOADER = "MODULE_AUTH_SET_LOADER";
export const MODULE_AUTH_HANDLE_STATE_FORM = "MODULE_AUTH_HANDLE_STATE_FORM";
export const MODULE_AUTH_HANDLE_STATE_FORM_REGISTER = "MODULE_AUTH_HANDLE_STATE_FORM_REGISTER";
export const MODULE_AUTH_HANDLE_STATE_FORM_REGISTER_KLINIK = "MODULE_AUTH_HANDLE_STATE_FORM_REGISTER_KLINIK";
export const MODULE_AUTH_HANDLE_STATE_FORM_VERIFIKASI_PASSWORD = "MODULE_AUTH_HANDLE_STATE_FORM_VERIFIKASI_PASSWORD";
export const MODULE_AUTH_INIT_FORM = "MODULE_AUTH_INIT_FORM";
export const MODULE_AUTH_INIT_FORM_REGISTER = "MODULE_AUTH_INIT_FORM_REGISTER";
export const MODULE_AUTH_INIT_FORM_REGISTER_KLINIK = "MODULE_AUTH_INIT_FORM_REGISTER_KLINIK";
export const MODULE_AUTH_INIT_FORM_VERIFIKASI_PASSWORD = "MODULE_AUTH_INIT_FORM_VERIFIKASI_PASSWORD";
export const MODULE_AUTH_SUBMIT_FORM_LOGIN = "MODULE_AUTH_SUBMIT_FORM_LOGIN";
export const MODULE_AUTH_SUBMIT_FORM_REGISTER = "MODULE_AUTH_SUBMIT_FORM_REGISTER";
export const MODULE_AUTH_SUBMIT_FORM_REGISTER_KLINIK = "MODULE_AUTH_SUBMIT_FORM_REGISTER_KLINIK";
export const MODULE_AUTH_SUBMIT_VERIFIKASI_PASSWORD = "MODULE_AUTH_SUBMIT_VERIFIKASI_PASSWORD";
export const MODULE_AUTH_LOGOUT = "MODULE_AUTH_LOGOUT";
export const MODULE_AUTH_CHECK_URL = "MODULE_AUTH_CHECK_URL";
export const MODULE_AUTH_CHECK_URL_SUCCESS = "MODULE_AUTH_CHECK_URL_SUCCESS";

// MODULE REKAM MEDIS
export const MODULE_REKAMMEDIS_SET_LOADER = "MODULE_REKAMMEDIS_SET_LOADER";
export const MODULE_REKAMMEDIS_LISTDATA_REKAMMEDIS_GET = "MODULE_REKAMMEDIS_LISTDATA_REKAMMEDIS_GET";
export const MODULE_REKAMMEDIS_LISTDATA_REKAMMEDIS_GET_SUCCESS = "MODULE_REKAMMEDIS_LISTDATA_REKAMMEDIS_GET_SUCCESS";
export const MODULE_REKAMMEDIS_DETAIL_REKAMMEDIS_GET = "MODULE_REKAMMEDIS_DETAIL_REKAMMEDIS_GET";
export const MODULE_REKAMMEDIS_DETAIL_REKAMMEDIS_GET_SUCCESS = "MODULE_REKAMMEDIS_DETAIL_REKAMMEDIS_GET_SUCCESS";

// MODULE REPORT
export const MODULE_REPORT_SET_LOADER = "MODULE_REPORT_SET_LOADER";
export const MODULE_REPORT_LISTDATA_ICD_PASIEN = "MODULE_REPORT_LISTDATA_ICD_PASIEN";
export const MODULE_REPORT_LISTDATA_ICD_PASIEN_SUCCESS = "MODULE_REPORT_LISTDATA_ICD_PASIEN_SUCCESS";
export const MODULE_REPORT_LISTDATA_KUNJUNGAN_PASIEN = "MODULE_REPORT_LISTDATA_KUNJUNGAN_PASIEN";
export const MODULE_REPORT_LISTDATA_KUNJUNGAN_PASIEN_SUCCESS = "MODULE_REPORT_LISTDATA_KUNJUNGAN_PASIEN_SUCCESS";
export const MODULE_REPORT_LISTDATA_TRANSAKSI_MASUK_PASIEN = "MODULE_REPORT_LISTDATA_TRANSAKSI_MASUK_PASIEN";
export const MODULE_REPORT_LISTDATA_TRANSAKSI_MASUK_PASIEN_SUCCESS = "MODULE_REPORT_LISTDATA_TRANSAKSI_MASUK_PASIEN_SUCCESS";
export const MODULE_REPORT_HANDLE_STATE_OUTER = "MODULE_REPORT_HANDLE_STATE_OUTER";
